import styled from 'styled-components';

import { media } from 'shared/helpers/styling/styling';

export const StyledHedgesFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${media.phone`
  flex-direction: column;
  align-items: center;
`}
  ${media.largeTablet`
justify-content: center;
`}
${media.tablet`
justify-content: center;
`}
`;

export const StyledHedgesFiltersItem = styled.div`
  width: 360px;
  ${media.phone`
  width: 250px;
`}
`;
